export const FETCH_ALL_PAYMENT = 'fetch_all_payment';
export const FETCH_ALL_PAYMENT_SUCCESS = 'fetch_all_payment_success';
export const PAYMENT_POPUP_STATUS_CHANGE =
  "payment_popup_status_change";
export const PAYMENT_BULK_UPDATE_POPUP_STATUS_CHANGE =
  "payment_bulk_update_popup_status_change";
export const FILTER_PAYMENT = "filter_payment";
export const FILTER_PAYMENT_SUCCESS = "filter_payment_success";
export const INIT_PAYMENT = "init_payment";
export const SET_PAYMENT = "set_payment";
export const UPDATE_PAYMENT = "update_payment";
export const UPDATE_PAYMENT_SUCCESS = "update_payment_success";
export const CREATE_PAYMENT = "create_payment";
export const CREATE_PAYMENT_SUCCESS = "create_payment_success";
export const UPDATE_BULK = "update_bulk";
export const UPDATE_BULK_SUCCESS = "update_bulk_success";
export const CHANGE_SELECT_ALL_STATUS = "change_select_all_status";
export const ON_CHANGE_UNCHECKED_PAYMENT_LIST = "on_change_unchecked_payment_list";
export const ON_CHANGE_PAGE_CHECKED_PAYMENT_LIST = "on_change_page_checked_payment_list";
export const ON_CHANGE_NON_SELECT_ALL_CHECKED_PAYMENT_LIST = "on_change_non_select_all_checked_payment_list";